import React, { FC, useState } from 'react';
import CustomScroll from 'react-custom-scroll';
import { connect } from 'react-redux';

import Button from '@components/Button';
import ListFilter from '@components/ListFilter';
import ServiceListFilter from '@components/ServiceListFilter';

import {
  applyFilters,
  changeFilter,
  changeSearchValue,
  resetFilters,
} from '@store/actions';
import st from './Filters.module.css';
import {
  FiltersSelectorProps,
  FiltersStructuredSelector,
} from './structuredSelector';

const plural = require('plural-ru');

export const getOfficesCountString = (count, pristine = false) => {
  if (count === 0) return 'Центров госуслуг не найдено';

  return pristine
    ? `Всего ${count}${plural(count, ' центр', ' центра', ' центров')}`
    : `${plural(count, 'Найден', 'Найдено')} ${count}${plural(
        count,
        ' центр',
        ' центра',
        ' центров'
      )}`;
};

export const renderUndergroundBranches = (station) => (
  <>
    {station.colors.map((color) => (
      <i
        key={color}
        className={st.undergroundBranch}
        style={{ backgroundColor: color }}
      />
    ))}
  </>
);

interface FiltersProps extends FiltersSelectorProps {
  onClose: () => void;
  phone: boolean;
  service: ServiceTypeProps;
  changeSearchValue: (payload: any) => any;
  changeFilter: (payload: any) => any;
  resetFilters: () => any;
  applyFilters: () => any;
}

const Filters: FC<FiltersProps> = ({
  presentationalFilters,
  areasFilters,
  undergroundsFilters,
  allOfficesCount,
  filteredOfficesCount,
  presentationalOfficesCount,
  searchValues,
  anyFiltersChanged,
  service,
  onClose,
  phone,
  changeSearchValue,
  changeFilter,
  resetFilters,
  applyFilters,
}) => {
  const [pristine, setPristine] = useState(true);

  const filterTypes = ['areas', 'undergrounds'];

  const officesCount = pristine
    ? presentationalOfficesCount
    : filteredOfficesCount;

  const resetInputs = (fields) => {
    fields.map((type) => changeSearchValue({ fieldName: type, value: '' }));
  };

  const handleApplyFilters = () => {
    setPristine(false);
    applyFilters();
    if (phone) onClose();
  };

  const handleResetFilters = () => {
    setPristine(true);
    resetFilters();
    resetInputs(filterTypes);
    if (phone) onClose();
  };

  const handleSetTargetPristine = () => {
    setPristine(false);
  };

  return (
    <div className={st.main} data-testid="filters">
      <div className={st.header}>
        <p className={st.title}>Фильтры</p>
        <button
          aria-label="filters"
          type="button"
          className={st.close}
          onClick={onClose}
        />
      </div>
      <div className={st.listFiltersWrapper}>
        <CustomScroll heightRelativeToParent="100%" allowOuterScroll>
          <ServiceListFilter
            service={service}
            handleSetTarget={handleSetTargetPristine}
          />
          <div className={st.listFilters}>
            <ListFilter
              dataTestId="areasListFilter"
              filterType="areas"
              title="Район"
              placeholder="Поиск по районам"
              filter={searchValues.areas}
              options={presentationalFilters.areas}
              selectedOptionsIds={areasFilters}
              handleSetTarget={handleSetTargetPristine}
              changeFilter={changeSearchValue}
              onChange={changeFilter}
            />
            <ListFilter
              dataTestId="undergroundsListFilter"
              filterType="undergrounds"
              title="Ближайшее метро"
              placeholder="Поиск по станциям"
              filter={searchValues.undergrounds}
              options={presentationalFilters.undergrounds}
              selectedOptionsIds={undergroundsFilters}
              handleSetTarget={handleSetTargetPristine}
              changeFilter={changeSearchValue}
              onChange={changeFilter}
              renderAdditional={renderUndergroundBranches}
            />
          </div>
        </CustomScroll>
      </div>
      <p data-testid="filtersCount" className={st.count}>
        {getOfficesCountString(officesCount, pristine)}
      </p>
      {((filteredOfficesCount > 0 &&
        filteredOfficesCount !== allOfficesCount) ||
        presentationalOfficesCount !== allOfficesCount) && (
        <div className={st.buttons}>
          {!anyFiltersChanged && (
            <Button dataTestId="sidebarShowButton" onClick={handleApplyFilters}>
              Показать
            </Button>
          )}
          <Button
            dataTestId="sidebarResetButton"
            onClick={handleResetFilters}
            className={st.resetButton}
          >
            Сбросить
          </Button>
        </div>
      )}
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  changeSearchValue: (payload) => dispatch(changeSearchValue(payload)),
  changeFilter: (payload) => dispatch(changeFilter(payload)),
  resetFilters: () => dispatch(resetFilters()),
  applyFilters: () => dispatch(applyFilters()),
});

export default connect(FiltersStructuredSelector, mapDispatchToProps)(Filters);
